import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    Aangifte,
    AangifteRapport, BokkzAlgDataService, IncomeTaxEntity,
    JaarrekeningVenW,
    JaarrekeningVenWKostensoort, Onderneming, Ondernemingsvorm
} from '@snelstart-ventures/fiscaal/domain-logic';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { Event, NavigationEnd, Router } from '@angular/router';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-winst-en-verlies',
    templateUrl: './winst-en-verlies.component.html',
    styleUrls: ['./winst-en-verlies.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        SharedUiDetailsModule,
        CommonModule
    ]
})
export class WinstEnVerliesComponent implements OnInit, OnDestroy {

    @Input() public id!: string;
    public clientId!: string;

    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;

    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private heeftSamenwerkingsverbandSubscription: Subscription | undefined;

    public isDefAangifte = {} as boolean;
    public showSpinner = true;
    public heeftRechtopOA = false;
    public heeftWuoPartner = false;
    public heeftWuoAangever = false;
    public heeftWuoStaking = false;
    public specJaarrekeningFg = {} as FormGroup;
    public rapport = {} as AangifteRapport;
    public wuoOpbrengstenFg = {} as FormGroup;
    public financieleBatenFg = {} as FormGroup;
    public buitengewoneBatenFg = {} as FormGroup;
    public wuoVrijgesteldeWinstbestanddelenFg = {} as FormGroup;
    public wuoStakingswinstenFg = {} as FormGroup;
    public wuoInkoopkostenFg = {} as FormGroup;
    public wuoVerkoopkostenFg = {} as FormGroup;
    public wuoPersoneelskostenFg = {} as FormGroup;
    public wuoHuisvestingskostenFg = {} as FormGroup;
    public wuoAutokostenFg = {} as FormGroup;
    public wuoAfschrijvingenFg = {} as FormGroup;
    public wuoOverigekostenFg = {} as FormGroup;
    public wuoFinancieleLastenFg = {} as FormGroup;
    public wuoBuitengewoneLastenFg = {} as FormGroup;
    public tussentellingenFg = {} as FormGroup;

    public heeftSamenwerkingsverband = {} as boolean;

    getTussentellingOpbrengsten(): number {
        const wuoOpbrengsten = this.wuoOpbrengstenFg.get('bedrag')?.value || 0;
        const financieleBaten = this.financieleBatenFg.get('bedrag')?.value || 0;
        const buitengewoneBaten = this.buitengewoneBatenFg.get('bedrag')?.value || 0;
        // const wuoVrijgesteldeWinstbestanddelen = this.wuoVrijgesteldeWinstbestanddelenFg.get('bedrag')?.value || 0;
        const wuoStakingswinsten = this.wuoStakingswinstenFg.get('bedrag')?.value || 0;
        return wuoOpbrengsten + financieleBaten + buitengewoneBaten + wuoStakingswinsten;
    }

    getTussentellingKosten(): number {
        const wuoInkoopkosten = this.wuoInkoopkostenFg.get('bedrag')?.value || 0;
        const wuoVerkoopkosten = this.wuoVerkoopkostenFg.get('bedrag')?.value || 0;
        const wuoPersoneelskosten = this.wuoPersoneelskostenFg.get('bedrag')?.value || 0;
        const wuoHuisvestingskosten = this.wuoHuisvestingskostenFg.get('bedrag')?.value || 0;
        const wuoAutokosten = this.wuoAutokostenFg.get('bedrag')?.value || 0;
        const wuoAfschrijvingen = this.wuoAfschrijvingenFg.get('bedrag')?.value || 0;
        const wuoOverigekosten = this.wuoOverigekostenFg.get('bedrag')?.value || 0;
        const wuoFinancieleLasten = this.wuoFinancieleLastenFg.get('bedrag')?.value || 0;
        const wuoBuitengewoneLasten = this.wuoBuitengewoneLastenFg.get('bedrag')?.value || 0;
        const totaal = wuoInkoopkosten + wuoVerkoopkosten + wuoPersoneelskosten + wuoHuisvestingskosten + wuoAutokosten + wuoAfschrijvingen +
            wuoOverigekosten + wuoFinancieleLasten + wuoBuitengewoneLasten;

        return (totaal);
    }

    getWinstResultatenrekening(): number {
        const wuoOpbrengsten = this.getTussentellingOpbrengsten() || 0;
        const wuoKosten = this.getTussentellingKosten() || 0;

        return (wuoOpbrengsten - wuoKosten);
    }

    constructor(private fb: FormBuilder, private router: Router, public dataService: BokkzIbDataService, private dataAlgService: BokkzAlgDataService) {
        this.wuoOpbrengstenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number
        });
        this.financieleBatenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number
        });
        this.buitengewoneBatenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number
        });
        this.wuoVrijgesteldeWinstbestanddelenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number
        });
        this.wuoStakingswinstenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number
        });
        this.wuoInkoopkostenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.INKOOPKOSTEN
        });
        this.wuoVerkoopkostenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.VERKOOPKOSTEN
        });
        this.wuoPersoneelskostenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.PERSONEELSKOSTEN
        });
        this.wuoHuisvestingskostenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.HUISVESTINGSKOSTEN
        });
        this.wuoAutokostenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.AUTOKOSTEN
        });
        this.wuoAfschrijvingenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.AFSCHRIJVINGEN
        });
        this.wuoOverigekostenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.OVERIGE
        });
        this.wuoFinancieleLastenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number
        });
        this.wuoBuitengewoneLastenFg = this.fb.group<JaarrekeningVenW>({
            bedrag: null as unknown as number
        });
        this.tussentellingenFg = this.fb.group({
            tussentellingOpbrengsten: null as unknown as number,
            tussentellingKosten: null as unknown as number,
            tussentellingRest: null as unknown as number,
            winstResultatenrekening: null as unknown as number
        });
    }

    formStructure: any;

    private resetFormGroups() {
        this.wuoOpbrengstenFg.setValue({ bedrag: null as unknown as number }, { emitEvent: false });
        this.financieleBatenFg.setValue({ bedrag: null as unknown as number }, { emitEvent: false });
        this.buitengewoneBatenFg.setValue({ bedrag: null as unknown as number }, { emitEvent: false });
        this.wuoVrijgesteldeWinstbestanddelenFg.reset();
        this.wuoStakingswinstenFg.reset();
        this.wuoInkoopkostenFg.setValue({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.INKOOPKOSTEN
        }, { emitEvent: false });
        this.wuoVerkoopkostenFg.setValue({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.VERKOOPKOSTEN
        }, { emitEvent: false });
        this.wuoPersoneelskostenFg.setValue({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.PERSONEELSKOSTEN
        }, { emitEvent: false });
        this.wuoHuisvestingskostenFg.setValue({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.HUISVESTINGSKOSTEN
        }, { emitEvent: false });
        this.wuoAutokostenFg.setValue({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.AUTOKOSTEN
        }, { emitEvent: false });
        this.wuoAfschrijvingenFg.setValue({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.AFSCHRIJVINGEN
        }, { emitEvent: false });
        this.wuoOverigekostenFg.setValue({
            bedrag: null as unknown as number,
            kostensoort: JaarrekeningVenWKostensoort.OVERIGE
        }, { emitEvent: false });
        this.wuoFinancieleLastenFg.setValue({ bedrag: null as unknown as number }, { emitEvent: false });
        this.wuoBuitengewoneLastenFg.setValue({ bedrag: null as unknown as number }, { emitEvent: false });
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
        this.dataService.heeftSamenwerkingsverbandWuo.subscribe((heeftSamenwerkingsverband) => {
            this.heeftSamenwerkingsverband = heeftSamenwerkingsverband;
        });
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            if (incomeTaxEntity.aangifte) {
                this.dataService.heeftWinstUitOndernemingAangever.subscribe((heeftWinstUitOndernemingAangever) => {
                    this.heeftWuoAangever = heeftWinstUitOndernemingAangever;
                });
                this.dataService.heeftWinstUitOndernemingPartner.subscribe((heeftWinstUitOndernemingPartner) => {
                    this.heeftWuoPartner = heeftWinstUitOndernemingPartner;
                });
                this.tussentellingenFg.get('winstResultatenrekening')?.valueChanges.subscribe(value => {
                    this.dataService.setWinstResultatenrekening(value);
                });
                this.incomeTaxEntity = incomeTaxEntity;
                if (incomeTaxEntity.aangifte) {
                    const aangifte = incomeTaxEntity.aangifte as Aangifte;
                    this.partner.subscribe((partnerBoolean) => {
                        this.partnerBoolean = partnerBoolean;
                        this.heeftRechtopOA = false;
                        this.heeftWuoStaking = false;
                        if (!this.partnerBoolean) {
                            if (this.heeftWuoAangever) {
                                this.heeftRechtopOA = true;
                            }
                            if (aangifte.box1?.winstUitOnderneming?.ondernemingen[0].datumStaking) {
                                const stakingJaar = new Date(aangifte.box1.winstUitOnderneming.ondernemingen[0].datumStaking).getFullYear();
                                if (stakingJaar === aangifte.aangifteJaar) {
                                    this.heeftWuoStaking = true;
                                }
                            } else {
                                this.heeftWuoStaking = false;
                            }
                        } else {
                            if (this.heeftWuoPartner) {
                                this.heeftRechtopOA = true;
                            }
                            if (aangifte.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0].datumStaking) {
                                const stakingJaar = new Date(aangifte.partnerAangifte.box1.winstUitOnderneming.ondernemingen[0].datumStaking).getFullYear();
                                if (stakingJaar === aangifte.aangifteJaar) {
                                    this.heeftWuoStaking = true;
                                }
                            } else {
                                this.heeftWuoStaking = false;
                            }
                        }
                        if (!partnerBoolean) {
                            this.resetFormGroups();
                            const onderneming = this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0];
                            if (onderneming) {
                                this.patchProfitLossFormgroup(onderneming);
                            }
                        }
                        if (partnerBoolean) {
                            this.resetFormGroups();
                            const ondernemingPartner = this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0];
                            if (ondernemingPartner) {
                                this.patchProfitLossFormgroup(ondernemingPartner);
                            }
                        }
                        this.updateHeeftSamenwerkingsverband();
                    });
                }
            }
        });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.clientId = client.sstRelationId!;
        });
        this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    private updateHeeftSamenwerkingsverband(): void {
        const ondernemingen = this.partnerBoolean
            ? this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen
            : this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen;

        if (ondernemingen && ondernemingen.length > 0 && ondernemingen[0].ondernemingsvorm !== Ondernemingsvorm.EENMANSZAAK) {
            this.heeftSamenwerkingsverband = ondernemingen[0].invullenOpNiveauSamenwerkingsverband != undefined && ondernemingen[0].invullenOpNiveauSamenwerkingsverband ;
        } else {
            this.heeftSamenwerkingsverband = false;
        }
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe();
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe();
        }
        if (this.heeftSamenwerkingsverbandSubscription) {
            this.heeftSamenwerkingsverbandSubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.wuoOpbrengstenFg.dirty ||
            this.financieleBatenFg.dirty ||
            this.buitengewoneBatenFg.dirty ||
            this.wuoVrijgesteldeWinstbestanddelenFg.dirty ||
            this.wuoStakingswinstenFg.dirty ||
            this.wuoInkoopkostenFg.dirty ||
            this.wuoVerkoopkostenFg.dirty ||
            this.wuoPersoneelskostenFg.dirty ||
            this.wuoHuisvestingskostenFg.dirty ||
            this.wuoAutokostenFg.dirty ||
            this.wuoAfschrijvingenFg.dirty ||
            this.wuoOverigekostenFg.dirty ||
            this.wuoFinancieleLastenFg.dirty ||
            this.wuoBuitengewoneLastenFg.dirty ||
            this.tussentellingenFg.dirty;
    }


    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.incomeTaxEntity.aangifte,
                box1: {
                    ...this.incomeTaxEntity.aangifte?.box1,
                    winstUitOnderneming: {
                        ...this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming,
                        ondernemingen: [
                            {
                                ...this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0],
                                wuoOpbrengsten: [this.wuoOpbrengstenFg.getRawValue()],
                                financieleBaten: [this.financieleBatenFg.getRawValue()],
                                buitengewoneBaten: [this.buitengewoneBatenFg.getRawValue()],
                                wuoVrijgesteldeWinstbestanddelen: [this.wuoVrijgesteldeWinstbestanddelenFg.getRawValue()],
                                wuoStakingswinsten: [this.wuoStakingswinstenFg.getRawValue()],
                                wuoKosten: [
                                    this.wuoInkoopkostenFg.getRawValue(),
                                    this.wuoVerkoopkostenFg.getRawValue(),
                                    this.wuoPersoneelskostenFg.getRawValue(),
                                    this.wuoHuisvestingskostenFg.getRawValue(),
                                    this.wuoAutokostenFg.getRawValue(),
                                    this.wuoAfschrijvingenFg.getRawValue(),
                                    this.wuoOverigekostenFg.getRawValue()],
                                financieleLasten: [this.wuoFinancieleLastenFg.getRawValue()],
                                buitengewoneLasten: [this.wuoBuitengewoneLastenFg.getRawValue()]
                            }]
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.incomeTaxEntity.aangifte,
                partnerAangifte: {
                    ...this.incomeTaxEntity.aangifte?.partnerAangifte,
                    box1: {
                        ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1,
                        winstUitOnderneming: {
                            ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming,
                            ondernemingen: [
                                {
                                    ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0],
                                    wuoOpbrengsten: [this.wuoOpbrengstenFg.getRawValue()],
                                    financieleBaten: [this.financieleBatenFg.getRawValue()],
                                    buitengewoneBaten: [this.buitengewoneBatenFg.getRawValue()],
                                    wuoVrijgesteldeWinstbestanddelen: [this.wuoVrijgesteldeWinstbestanddelenFg.getRawValue()],
                                    wuoStakingswinsten: this.wuoStakingswinstenFg.getRawValue() != null ? [this.wuoStakingswinstenFg.getRawValue()] : undefined,
                                    wuoKosten: [
                                        this.wuoInkoopkostenFg.getRawValue(),
                                        this.wuoVerkoopkostenFg.getRawValue(),
                                        this.wuoPersoneelskostenFg.getRawValue(),
                                        this.wuoHuisvestingskostenFg.getRawValue(),
                                        this.wuoAutokostenFg.getRawValue(),
                                        this.wuoAfschrijvingenFg.getRawValue(),
                                        this.wuoOverigekostenFg.getRawValue()],
                                    financieleLasten: [this.wuoFinancieleLastenFg.getRawValue()],
                                    buitengewoneLasten: [this.wuoBuitengewoneLastenFg.getRawValue()]
                                }]

                        }
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        }
    }

    private getRelevantAangifte(): Aangifte | undefined {
        return this.partnerBoolean
            ? this.incomeTaxEntity.aangifte?.partnerAangifte
            : this.incomeTaxEntity.aangifte;
    }

    private getOndernemingen(): Onderneming[] | undefined {
        const aangifte = this.getRelevantAangifte();
        return aangifte?.box1?.winstUitOnderneming?.ondernemingen;
    }

    public heeftOndernemingen(): boolean {
        const ondernemingen = this.getOndernemingen();
        return !!ondernemingen && ondernemingen.length > 0;
    }

    private patchProfitLossFormgroup(onderneming: Onderneming) {
        const wuoOpbrengsten = onderneming.wuoOpbrengsten?.at(0);
        const financieleBaten = onderneming.financieleBaten?.at(0);
        const buitengewoneBaten = onderneming.buitengewoneBaten?.at(0);
        const wuoVrijgesteldeWinstbestanddelen = onderneming.wuoVrijgesteldeWinstbestanddelen?.at(0);
        const wuoStakingswinsten = onderneming.wuoStakingswinsten?.at(0);
        if (wuoOpbrengsten) {
            this.wuoOpbrengstenFg.patchValue(wuoOpbrengsten, { emitEvent: false });
        }
        if (financieleBaten) {
            this.financieleBatenFg.patchValue(financieleBaten, { emitEvent: false });
        }
        if (buitengewoneBaten) {
            this.buitengewoneBatenFg.patchValue(buitengewoneBaten, { emitEvent: false });
        }

        if (this.isDefAangifte && wuoVrijgesteldeWinstbestanddelen) {
            this.wuoVrijgesteldeWinstbestanddelenFg.patchValue(wuoVrijgesteldeWinstbestanddelen, { emitEvent: false });
        }
        if (wuoStakingswinsten) {
            this.wuoStakingswinstenFg.patchValue(wuoStakingswinsten, { emitEvent: false });
        }

        const inkoopkostenItem = onderneming?.wuoKosten?.find(item => item.kostensoort == JaarrekeningVenWKostensoort.INKOOPKOSTEN);
        const verkoopKostenItem = onderneming?.wuoKosten?.find(item => item.kostensoort == JaarrekeningVenWKostensoort.VERKOOPKOSTEN);
        const personeelKostenItem = onderneming?.wuoKosten?.find(item => item.kostensoort == JaarrekeningVenWKostensoort.PERSONEELSKOSTEN);
        const huisvestingsKostenItem = onderneming?.wuoKosten?.find(item => item.kostensoort == JaarrekeningVenWKostensoort.HUISVESTINGSKOSTEN);
        const autokostenItem = onderneming?.wuoKosten?.find(item => item.kostensoort == JaarrekeningVenWKostensoort.AUTOKOSTEN);
        const afschrijvingenItem = onderneming?.wuoKosten?.find(item => item.kostensoort == JaarrekeningVenWKostensoort.AFSCHRIJVINGEN);
        const overigeKostenItem = onderneming?.wuoKosten?.find(item => item.kostensoort == JaarrekeningVenWKostensoort.OVERIGE);
        if (inkoopkostenItem) {
            this.wuoInkoopkostenFg.patchValue(inkoopkostenItem, { emitEvent: false });
        }
        if (verkoopKostenItem) {
            this.wuoVerkoopkostenFg.patchValue({ bedrag: verkoopKostenItem.bedrag }, { emitEvent: false });
        }
        if (personeelKostenItem) {
            this.wuoPersoneelskostenFg.patchValue({ bedrag: personeelKostenItem.bedrag }, { emitEvent: false });
        }
        if (huisvestingsKostenItem) {
            this.wuoHuisvestingskostenFg.patchValue({ bedrag: huisvestingsKostenItem.bedrag }, { emitEvent: false });
        }
        if (autokostenItem) {
            this.wuoAutokostenFg.patchValue({ bedrag: autokostenItem.bedrag }, { emitEvent: false });
        }
        if (afschrijvingenItem) {
            this.wuoAfschrijvingenFg.patchValue({ bedrag: afschrijvingenItem.bedrag }, { emitEvent: false });
        }
        if (overigeKostenItem) {
            this.wuoOverigekostenFg.patchValue({ bedrag: overigeKostenItem.bedrag }, { emitEvent: false });
        }

        const financieleLasten = onderneming.financieleLasten?.at(0);
        const buitengewoneLasten = onderneming.buitengewoneLasten?.at(0);
        if (financieleLasten) {
            this.wuoFinancieleLastenFg.patchValue(financieleLasten, { emitEvent: false });
        }
        if (buitengewoneLasten) {
            this.wuoBuitengewoneLastenFg.patchValue(buitengewoneLasten, { emitEvent: false });
        }

        const tussentellingOpbrengsten = this.getTussentellingOpbrengsten();
        const tussentellingKosten = this.getTussentellingKosten();
        const winstResultatenrekening = this.getWinstResultatenrekening();
        this.tussentellingenFg.patchValue({ tussentellingOpbrengsten: tussentellingOpbrengsten });
        this.tussentellingenFg.patchValue({ tussentellingKosten: tussentellingKosten });
        this.tussentellingenFg.patchValue({ winstResultatenrekening: winstResultatenrekening });
    }
}



